"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var fp_1 = require("lodash/fp");
var _assignFieldIndices = function (fields) {
    var bitset = [];
    var fieldKeys = Object.keys(fields);
    var _a = fieldKeys.reduce(function (f, fieldKey) {
        if (typeof fields[fieldKey].index === 'number') {
            bitset[fields[fieldKey].index] = 1;
            f.fieldsWithIndices.push(fieldKey);
        }
        else {
            f.fieldsWithoutIndices.push(fieldKey);
        }
        return f;
    }, {
        fieldsWithoutIndices: [],
        fieldsWithIndices: []
    }), fieldsWithIndices = _a.fieldsWithIndices, fieldsWithoutIndices = _a.fieldsWithoutIndices;
    var indicesAreNotSparse = bitset.length === fieldKeys.length &&
        bitset.join('').length === fieldKeys.length;
    if (indicesAreNotSparse) {
        return fields;
    }
    var newFields = __assign({}, fields);
    fieldsWithIndices
        .sort(function (a, b) { return fields[a].index - fields[b].index; })
        .forEach(function (fieldKey, i) {
        return (newFields[fieldKey] = fp_1.set('index', i, newFields[fieldKey]));
    });
    fieldsWithoutIndices.forEach(function (fieldKey, i) {
        return (newFields[fieldKey] = fp_1.set('index', fieldsWithIndices.length + i, newFields[fieldKey]));
    });
    return newFields;
};
var addFieldIndicesIfNeeded = function (schema) { return (__assign(__assign({}, schema), { fields: _assignFieldIndices(schema.fields) })); };
module.exports = addFieldIndicesIfNeeded;
//# sourceMappingURL=normalizeFieldIndices.js.map